export const QUERY_CONSTANTS = {
  GET_ALL_GYM_LISTING_WITH_PAGINATION: "GET_ALL_GYM_LISTING_WITH_PAGINATION",
  GET_REFERRAL_MEMBERS: "GET_REFERRAL_MEMBERS",
  GET_ALL_INVOICES: "GET_ALL_INVOICES",
  GET_REFERRAL_SETTINGS: "GET_REFERRAL_SETTINGS",
  GET_LOYALTY_SETTINGS: "GET_LOYALTY_SETTINGS",
  GET_LOYALTY_HISTORY: "GET_LOYALTY_HISTORY",
  GET_LOYALTY_USER_BALANCE: "GET_LOYALTY_USER_BALANCE",
  GET_ALL_ADMINS: "GET_ALL_ADMINS",
  GET_ALL_SUPPORTS: "GET_ALL_SUPPORTS",
  GET_ALL_SUBSCRIPTIONS: "GET_ALL_SUBSCRIPTIONS",
  GET_ALL_ADDONS: "GET_ALL_ADDONS",
  GET_STATISTICS_SUMMARY: "GET_STATISTICS_SUMMARY",
  GET_STATISTICS_REVENUE: "GET_STATISTICS_REVENUE",
  GET_ALL_COUNTRIES: "GET_ALL_COUNTRIES",
  GET_GYM_LISTING_PREVIEW_BY_ID: "GET_GYM_LISTING_PREVIEW_BY_ID",
  GET_CONTRACTS: "GET_CONTRACTS",
  GET_GYM_LISTING_FOR_ASSIGN_CONTRACT_SELECT: "GET_GYM_LISTING_FOR_ASSIGN_CONTRACT_SELECT",
  GET_CONTRACTS_FOR_ASSIGN: "GET_CONTRACTS_FOR_ASSIGN",
  GET_ALL_REVIEWS_WITH_PAGINATION: "GET_ALL_REVIEWS_WITH_PAGINATION",
  GET_ALL_CLASSES_BY_GYM: "GET_ALL_CLASSES_BY_GYM",
  GET_ALL_CLASSES_CATEGORIES: "GET_ALL_CLASSES_CATEGORIES",
  GET_SETTINGS: "GET_SETTINGS",
  GET_ALL_RESERVATIONS: "GET_ALL_RESERVATIONS",
  GET_GYM_NOTIFICATION_GYMS: "GET_GYM_NOTIFICATION_GYMS",
  GET_GYM_NOTIFICATION_BY_GYM_LISTING_ID: "GET_GYM_NOTIFICATION_BY_GYM_LISTING_ID",
  GET_GYM_NOTIFICATION_BY_USER_ID: "GET_GYM_NOTIFICATION_BY_USER_ID",
  GET_GYM_OPEN_GYM_RESERVATIONS: "GET_GYM_OPEN_GYM_RESERVATIONS",
  GET_MAINTENANCE_SETTINGS: "GET_MAINTENANCE_SETTINGS",
  GET_EMAIL_TEMPLATE_VERSION_BY_LANGUAGE: "GET_EMAIL_TEMPLATE_VERSION_BY_LANGUAGE",
  GET_EMAIL_TEMPLATE_SUBJECTS: "GET_EMAIL_TEMPLATE_SUBJECTS",
  GET_EMAIL_TEMPLATE_CONSTANTS: "GET_EMAIL_TEMPLATE_CONSTANTS",
  GET_ALL_EMAIL_TEMPLATES: "GET_ALL_EMAIL_TEMPLATES",
  GET_EMAIL_TEMPLATE_BY_ID: "GET_EMAIL_TEMPLATE_BY_ID",
  GET_ALL_LAST_MINUTE_DEALS: "GET_ALL_LAST_MINUTE_DEALS",
  GET_LAST_MINUTE_DEAL_BY_ID: "GET_LAST_MINUTE_DEAL_BY_ID",
  GET_USER_SUBSCRIPTIONS_BY_USER: "GET_USER_SUBSCRIPTIONS_BY_USER",
  GET_USER_SUBSCRIPTION_CANCELLATION_REASON: "GET_USER_SUBSCRIPTION_CANCELLATION_REASON",
  GET_USER_SUBSCRIPTION_USER_LOGS: "GET_USER_SUBSCRIPTION_USER_LOGS",
};
